import { CdkDragDrop, moveItemInArray, transferArrayItem, CdkDragStart, } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Inject, QueryList, Renderer2, TemplateRef, ViewChild, ViewChildren } from '@angular/core';

import { Subject } from 'rxjs';
import { startOfMonth, endOfMonth, eachDayOfInterval, format, startOfWeek, getDay, subDays, addDays, isSameDay, parseISO, endOfWeek, subMonths, subWeeks } from 'date-fns';
import { Category, DayTimeHours, Flags, JobData, } from 'src/app/model/calendar';
import { E, P, S } from '@angular/cdk/keycodes';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { AddMultipleShiftComponent } from '../add-multiple-shift/add-multiple-shift.component';
import { MatDialog } from '@angular/material/dialog';
import { AddShiftComponent } from '../add-shift/add-shift.component';
import { RosterShiftComponent } from '../roster-shift/roster-shift.component';
import { CommonService } from 'src/app/services/common/common.service';
import { MatSelectChange } from '@angular/material/select';
import { ImportShiftCsvComponent } from '../import-shift-csv/import-shift-csv.component';
import { ListViewComponent } from '../list-view/list-view.component';
import { JobSchedulingSettingsComponent } from '../job-scheduling-settings/job-scheduling-settings.component';
import { hoverJS } from '../../../../assets/js/custom-hover.js'
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Filter } from '../../filter/filter.model';
import { RecConfirmModalComponent } from '../rec-confirm-modal/rec-confirm-modal.component';
import { ScheduleShiftConfirmationComponent } from '../schedule-shift-confirmation/schedule-shift-confirmation.component';
import { AddUnavailabilityComponent } from '../add-unavailability/add-unavailability.component';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { AppService } from 'src/app/services/app/app.service';
import { JobService } from 'src/app/services/job/job.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmationModalComponent } from '../../dialog-modal/confirmation-modal/confirmation-modal.component';
import { id } from '@swimlane/ngx-charts';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { StarRatingComponent } from '../../employees/star-rating/star-rating.component';
import { AddMultiduplicateComponent } from '../add-multiduplicate/add-multiduplicate.component';
import { CountWagesComponent } from '../count-wages/count-wages.component';
import { ViewUnavailabilityComponent } from '../view-unavailability/view-unavailability.component';
import { ViewEmployeeComponent } from '../../view-employee/view-employee.component';
import { FilterEventsPipe } from 'src/app/pipes/filter-events/filter-events.pipe';
import { ConflictsComponent } from '../conflicts/conflicts.component';
import { CookieService } from 'ngx-cookie-service';
import { aD } from '@fullcalendar/core/internal-common';
import { NewListViewComponent } from '../new-list-view/new-list-view.component';
import { GlobalService } from 'src/app/services/global/global.service';

@Component({
  selector: 'app-job-calendar',
  templateUrl: './job-calendar.component.html',
  styleUrls: ['./job-calendar.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({
        height: '0',
        overflow: 'hidden',
        opacity: 0,
        padding: '0' // Ensures padding doesn't affect animation
      })),
      state('expanded', style({
        height: '*',
        overflow: 'hidden',
        opacity: 1,
        padding: '*' // Restores padding to its natural state
      })),
      transition('collapsed => expanded', [
        style({ height: '0', overflow: 'hidden', opacity: 0, padding: '0' }),
        animate('300ms ease-in', style({ height: '*', opacity: 1, padding: '*' }))
      ]),
      transition('expanded => collapsed', [
        style({ height: '*', overflow: 'hidden', opacity: 1, padding: '*' }),
        animate('300ms ease-out', style({ height: '0', opacity: 0, padding: '0' }))
      ])
    ]),
    trigger('fadeAnimation', [
      transition(':enter', [
        style({ opacity: 0, height: 0, overflow: 'hidden' }),
        animate('300ms ease-in', style({ opacity: 1, height: '*', overflow: 'hidden' }))
      ]),
      transition(':leave', [
        style({ opacity: 1, height: '*', overflow: 'hidden' }),
        animate('300ms ease-out', style({ opacity: 0, height: 0, overflow: 'hidden' }))
      ])
    ]),
    trigger('fadeInOut', [
      state('hidden', style({
        opacity: 0,
        transform: 'scale(0.8)'
      })),
      state('visible', style({
        opacity: 1,
        transform: 'scale(1)'
      })),
      transition('hidden => visible', [
        animate('300ms ease-in')
      ]),
      transition('visible => hidden', [
        animate('300ms ease-out')
      ])
    ])
  ]
})

export class JobCalendarComponent {
  private resizeTimeout: any;
  public isSpinnerLoading: boolean = false;
  public recruiterArr: any[] = []
  public filterRecArr: any[] = [];
  public imageUrl: string = GlobalService.imageURL;
  expandedState: boolean[] = [];
  public dayTimeHours: DayTimeHours[] = [
    { time: '12 AM', val: 0 },
    { time: '1 AM', val: 1 },
    { time: '2 AM', val: 2 },
    { time: '3 AM', val: 3 },
    { time: '4 AM', val: 4 },
    { time: '5 AM', val: 5 },
    { time: '6 AM', val: 6 },
    { time: '7 AM', val: 7 },
    { time: '8 AM', val: 8 },
    { time: '9 AM', val: 9 },
    { time: '10 AM', val: 10 },
    { time: '11 AM', val: 11 },
    { time: '12 PM', val: 12 },
    { time: '1 PM', val: 13 },
    { time: '2 PM', val: 14 },
    { time: '3 PM', val: 15 },
    { time: '4 PM', val: 16 },
    { time: '5 PM', val: 17 },
    { time: '6 PM', val: 18 },
    { time: '7 PM', val: 19 },
    { time: '8 PM', val: 20 },
    { time: '9 PM', val: 21 },
    { time: '10 PM', val: 22 },
    { time: '11 PM', val: 23 },
    { time: '12 AM', val: 24 },
    { time: '1 AM', val: 25 },
    { time: '2 AM', val: 26 },
    { time: '3 AM', val: 27 },
    { time: '4 AM', val: 28 },
    { time: '5 AM', val: 29 },
    { time: '6 AM', val: 30 },
    { time: '7 AM', val: 31 },
    { time: '8 AM', val: 32 },
    { time: '9 AM', val: 33 },
    { time: '10 AM', val: 34 },
    { time: '11 AM', val: 35 },
    { time: '12 PM', val: 36 },
    { time: '1 PM', val: 37 },
    { time: '2 PM', val: 38 },
    { time: '3 PM', val: 39 },
    { time: '4 PM', val: 40 },
    { time: '5 PM', val: 41 },
    { time: '6 PM', val: 42 },
    { time: '7 PM', val: 43 },
    { time: '8 PM', val: 44 },
    { time: '9 PM', val: 45 },
    { time: '10 PM', val: 46 },
    { time: '11 PM', val: 47 },
  ]
  public categoryArr: Category[] = [
    {
      name: 'Kitchen Staff',
      j_c: 1,
      sub_a: [
        {
          s_n: 'Kitchen Porter',
          j_sc_id: 11
        },
        {
          s_n: 'Relief Chef',
          j_sc_id: 12
        },
      ]
    },
    {
      name: 'Food & Beverage Staff',
      j_c: 2,
      sub_a: [
        {
          s_n: 'Bar Staff',
          j_sc_id: 21
        },
        {
          s_n: 'Barista',
          j_sc_id: 22
        },
        {
          s_n: 'Waiting Staff',
          j_sc_id: 23
        },
      ]
    }
  ]
  public companyArr: any[] = [
    {
      name: "Ktech Security", img: "assets/images/ktech_logo.png", cname: "ktech",
      sub_a: [
        {
          s_n: 'Kitchen Porter',
          j_sc_id: 11
        },
        {
          s_n: 'Relief Chef',
          j_sc_id: 12
        },
      ]
    },
    {
      name: "Fitzer Catering", img: "assets/images/fitzer_logo.png", cname: "fitzer", sub_a: [
        {
          s_n: 'Bar Staff',
          j_sc_id: 21
        },
        {
          s_n: 'Barista',
          j_sc_id: 22
        },
        {
          s_n: 'Waiting Staff',
          j_sc_id: 23
        },
      ]
    },
  ]
  public companyUserArr: any[] = [
    {
      name: "Ktech Security", img: "", cname: "ktech",
      sub_a: [
        { s_n: "Vishva", e_i: 1, img: "" },
        { s_n: "Marcus Doe", e_i: 3, img: "" },
      ]
    },
    {
      name: "Fitzer Catering", img: "", cname: "fitzer", sub_a: [
        { s_n: "Krishna", e_i: 2, img: "" },
        { s_n: "Hiren Patel", e_i: 4, img: "" },
      ]
    },
  ]
  public userArr: any[] = [
    { name: "Vishva", e_i: 1, img: "" },
    { name: "Krishna", e_i: 2, img: "" }
  ]
  public locArr: any[] = [
    // { name: "Surat", add: "surat" },
    // { name: "Tapi", add: "tapi" }
    // { name: 'Aviva Stadium, Lansdowne Road, Dublin 4, Ireland Lansdowne Road Ireland', add: 'Aviva Stadium, Lansdowne Road, Dublin 4, Ireland Lansdowne Road Ireland' },
    // { name: 'Leopardstown Golf Centre, Foxrock, Dublin, Ireland Foxrock Ireland', add: 'Leopardstown Golf Centre, Foxrock, Dublin, Ireland Foxrock Ireland' }
  ]
  public addArr: any[] = [
    { name: "Instant Hire Shift", value: "instant_hire", userType: ['recruiter', 'company', 'admin'], },
    { name: "Add Single Shift", value: "single", userType: ['recruiter', 'company', 'admin'], },
    { name: "Add Multiple Shift", value: "multiple", userType: ['recruiter', 'company', 'admin'], },
    { name: "Hire Additional Resources", value: "additional_resource", userType: ['company'], },
    // { name: "Assign to Employee", value: "assign_employee" },
    { name: "Offer to Favourites", value: "assign_fav_employee", userType: ['recruiter', 'company'], },
    { name: "Import shifts from excel", value: "csv", userType: ['recruiter', 'company'], },
  ]
  public jobData: JobData[] = [
    // { "st_dt": "2024-08-02", "name": "Kitchen Staff", sub_c: 'Kitchen Porter', j_c: 1, j_sc_id: 11, "start_time": "05:00:00", "end_time": "09:00:00", em_i: "", add: "Aviva Stadium, Lansdowne Road, Dublin 4", j_id: 1, company_name: '', first_name: "", op_s: 1, qty: 15, },
    // { "st_dt": "2024-08-02", "name": "Kitchen Staff", sub_c: 'Kitchen Porter', j_c: 1, j_sc_id: 11, "start_time": "05:00:00", "end_time": "09:00:00", em_i: "", add: "Aviva Stadium, Lansdowne Road, Dublin 4", j_id: 1, company_name: '', first_name: "", op_s: 1, qty: 5 },
    // { "st_dt": "2024-08-19", "name": "Kitchen Staff", sub_c: 'Kitchen Porter', j_c: 1, j_sc_id: 11, "start_time": "05:00:00", "end_time": "09:00:00", em_i: 1, add: "Aviva Stadium, Lansdowne Road, Dublin 4", j_id: 1, company_name: 'ktech', first_name: "Vishva", co_name: "Ktech Security" },

    // { "st_dt": "2024-08-13", "name": "Kitchen Staff", sub_c: 'Kitchen Porter', j_c: 1, j_sc_id: 11, "start_time": "05:00:00", "end_time": "10:00:00", em_i: 1, add: "Aviva Stadium, Lansdowne Road, Dublin 4", j_id: 2, company_name: 'ktech', first_name: "Vishva", co_name: "Ktech Security" },

    // { "st_dt": "2024-08-02", "name": "Kitchen Staff", sub_c: 'Kitchen Porter', j_c: 1, j_sc_id: 11, "start_time": "05:00:00", "end_time": "08:00:00", em_i: 1, add: "Aviva Stadium, Lansdowne Road, Dublin 4", j_id: 0, company_name: 'ktech', first_name: "Vishva", co_name: "Ktech Security" },
    // { "st_dt": "2024-08-03", "name": "Kitchen Staff", sub_c: 'Kitchen Porter', j_c: 1, j_sc_id: 11, "start_time": "05:00:00", "end_time": "11:00:00", em_i: 1, add: "Aviva Stadium, Lansdowne Road, Dublin 4", j_id: 3, company_name: 'ktech', first_name: "Vishva", co_name: "Ktech Security" },
    // { "st_dt": "2024-08-02", "name": "Kitchen Staff", sub_c: 'Kitchen Porter', j_c: 1, j_sc_id: 11, "start_time": "05:00:00", "end_time": "08:00:00", em_i: 2, add: "Aviva Stadium, Lansdowne Road, Dublin 4", j_id: 4, company_name: 'ktech', first_name: "Krishna", co_name: "Ktech Security" },
    // { "st_dt": "2024-08-04", "name": "Kitchen Staff", sub_c: 'Kitchen Porter', j_c: 2, j_sc_id: 21, "start_time": "05:00:00", "end_time": "11:00:00", em_i: 1, add: "Leopardstown Golf Centre, Foxrock, Dublin", j_id: 3, company_name: 'fitzer', first_name: "Vishva", co_name: "Fitzer Catering" },
    // { "st_dt": "2024-08-05", "name": "Kitchen Staff", sub_c: 'Kitchen Porter', j_c: 1, j_sc_id: 11, "start_time": "05:00:00", "end_time": "08:00:00", em_i: 2, add: "Leopardstown Golf Centre, Foxrock, Dublin", j_id: 4, company_name: 'fitzer', first_name: "Krishna", co_name: "Fitzer Catering" },

    // { "st_dt": "2024-08-03", "name": "Food & Beverages Staff", sub_c: 'Bar Staff', j_c: 2, j_sc_id: 21, "start_time": "05:00:00", "end_time": "09:00:00", em_i: 2, add: "Leopardstown Golf Centre, Foxrock, Dublin", j_id: 5, company_name: 'fitzer', first_name: "Krishna", co_name: "Fitzer Catering" },
    // { "st_dt": "2024-07-30", "name": "Food & Beverages Staff", sub_c: 'Barista', j_c: 2, j_sc_id: 22, "start_time": "05:00:00", "end_time": "09:00:00", em_i: 2, add: "Aviva Stadium, Lansdowne Road, Dublin 4", j_id: 5, company_name: 'ktech', first_name: "Krishna", co_name: "Ktech Security" },
    // // { "st_dt": "2024-05-02", "name": "Kitchen 8", category: 1, j_sc_id: 11, "start_time": "05:00:00", "end_time": "8:00:00", em_i:1 ,add:"surat",},
    // { "st_dt": "2024-05-01", "name": "Kitchen 4", category: 1, j_sc_id: 11, "start_time": "00:00:00", "end_time": "08:00:00", em_i:1 ,add:"surat", },
    // { "st_dt": "2024-05-03", "name": "Kitchen 5", category: 1, j_sc_id: 11, "start_time": "00:00:00", "end_time": "08:00:00", em_i:1 ,add:"surat",},
    // { "st_dt": "2024-05-23", "name": "Kitchen 6", category: 1, j_sc_id: 11, "start_time": "00:00:00", "end_time": "08:00:00", em_i:1 ,add:"surat",},

    // { "st_dt": "2024-07-02", "name": "Kitchen Staff", sub_c: 'Kitchen Porter', category: 1, j_sc_id: 11, "start_time": "05:00:00", "end_time": "11:00:00", em_i: 1, add: "surat", j_id: 3 },
    // { "st_dt": "2024-07-02", "name": "Kitchen Staff", sub_c: 'Kitchen Porter', category: 1, j_sc_id: 11, "start_time": "05:00:00", "end_time": "08:00:00", em_i: 2, add: "surat", j_id: 4 },
    // { "st_dt": "2024-07-02", "name": "Food & Beverages Staff", sub_c: 'Kitchen Porter', category: 1, j_sc_id: 11, "start_time": "05:00:00", "end_time": "09:00:00", e_i: 2, add: "tapi", j_id: 5 },

    // { "st_dt": "2024-07-02", "name": "Kitchen Staff", sub_c: 'Kitchen Porter', category: 1, j_sc_id: 11, "start_time": "05:00:00", "end_time": "11:00:00", em_i: 1, add: "surat", j_id: 3 },
    // { "st_dt": "2024-07-02", "name": "Kitchen Staff", sub_c: 'Kitchen Porter', category: 1, j_sc_id: 11, "start_time": "05:00:00", "end_time": "08:00:00", em_i: 2, add: "surat", j_id: 4 },
    // { "st_dt": "2024-07-02", "name": "Food & Beverages Staff", sub_c: 'Kitchen Porter', category: 1, j_sc_id: 11, "start_time": "05:00:00", "end_time": "09:00:00", e_i: 2, add: "tapi", j_id: 5 },

    // { "st_dt": "2024-07-12", "name": "Food & Beverages Staff", sub_c: 'Bar Staff', j_c: 2, j_sc_id: 21, "start_time": "05:00:00", "end_time": "09:00:00", em_i: 2, add: "tapi", j_id: 5 },
    // { "st_dt": "2024-07-12", "name": "Food & Beverages Staff", sub_c: 'Barista', j_c: 2, j_sc_id: 22, "start_time": "07:00:00", "end_time": "12:15:00", em_i: 2, add: "tapi", j_id: 6 },
    // { "st_dt": "2024-05-02", "name": "Food & Beverages Staff", sub_c: 'Barista', j_c: 2, j_sc_id: 22, "start_time": "01:00:00", "end_time": "08:00:00", em_i: 2, add: "tapi", j_id: 7 },
    // { "st_dt": "2024-05-25", "name": "Food & Beverages Staff", sub_c: 'Waiting Staff', j_c: 2, j_sc_id: 23, "start_time": "13:00:00", "end_time": "18:00:00", em_i: 2, add: "tapi", j_id: 8, },
    // { "st_dt": "2024-05-25", "name": "Food & Beverages Staff", sub_c: 'Waiting Staff', j_c: 2, j_sc_id: 23, "start_time": "13:00:00", "end_time": "18:00:00", em_i: 2, add: "tapi", j_id: 9 },

    // { "st_dt": "2024-05-25", "name": "Kitchen 3", category: 1, j_sc_id: 11, "start_time": "17:00:00", "end_time": "23:00:00",  em_i:1 ,add:"tapi",},


    // { "st_dt": "2024-05-13", "name": "job 2", category: 1, j_sc_id: 11, "start_time": "09:00:00", "end_time": "08:00:00", st: 4, ed: 9 },

    // { "st_dt": "2024-05-18", "name": "job 2", category: 2, j_sc_id: 21, "start_time": "09:00:00", "end_time": "08:00:00", st: 4, ed: 9 },
    // { "st_dt": "2024-05-18", "name": "job 2", category: 2, j_sc_id: 21, "start_time": "09:00:00", "end_time": "08:00:00", st: 4, ed: 9 },
    // { "st_dt": "2024-05-18", "name": "job 2", category: 2, j_sc_id: 21, "start_time": "09:00:00", "end_time": "08:00:00", st: 4, ed: 9 },
    // { "st_dt": "2024-05-18", "name": "job 2", category: 2, j_sc_id: 21, "start_time": "09:00:00", "end_time": "08:00:00", st: 4, ed: 9 },

    // { "st_dt": "2024-03-13", "name": "job 2", category: 1, j_sc_id: 12, "start_time": "12:12:00", "end_time": "16:12:00", },
  ]
  public filteredJobData: JobData[] = [];
  public boxWidth = 42;
  private m_pos!: number;
  private side!: string;
  private currentIndex!: number;
  public isResizing: boolean = false;

  isResizing2 = false;
  resizeDirection: 'left' | 'right' | null = null;
  resizingJob: any = null;
  startX = 0;
  startWidth = 0;
  startLeft = 0;

  currentWeek!: Date;
  currentMonth!: Date;
  currentDate!: Date;

  daysInMonth!: { date: Date, isCurrentMonth: boolean, events: any[], expanded: boolean, fDate: string, isToday: boolean, unav: any[] }[];
  daysInWeek!: {
    date: Date, day: string, month: string, dayOfWeek: string, events: any[], expanded: boolean, fDate: string, unav: any[],
    counting: {
      day_t_sh: 0,
      day_w_sh: 0,
      per: 0,
    }
  }[];
  daysInDay: any;

  daysOfWeek: string[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  weekHeader!: string;
  viewMode: string = 'month';
  viewType!: string;

  public viewTypeArr: any[] = []
  public weekCountingArr: any[] = []
  public weekCostCountingArr;
  public viewBy: string = 'category'
  public viewByOptions = {
    category: ['date', 'st_dt', 'category', 'j_c', 'j_sc'],
    user: ['em_i', 'date'],
    location: ['date', 'add'],
    company: ['date', 'company_name'],
    c_user: ['date', 'em_i', 'company_name'],
    c_category: ['date', 'company_name', 'j_sc', "j_c"]
    // c_category: ['date', 'company_name', "category", 'j_sc', "j_c"]
  }
  public viewByObj = {
    category: {
      arr: [
        {
          name: 'Kitchen Staff',
          j_c: 1,
          sub_a: [
            {
              s_n: 'Kitchen Porter',
              j_sc_id: 11
            },
            {
              s_n: 'Relief Chef',
              j_sc_id: 12
            },
          ]
        },
        {
          name: 'Food & Beverage Staff',
          j_c: 2,
          sub_a: [
            {
              s_n: 'Bar Staff',
              j_sc_id: 21
            },
            {
              s_n: 'Barista',
              j_sc_id: 22
            },
            {
              s_n: 'Waiting Staff',
              j_sc_id: 23
            },
          ]
        }
      ]
    },
    user: {
      arr: [
        { name: "Vishva", e_i: 1, img: "" },
        { name: "Krishna", e_i: 2, img: "" }
      ]
    },
    location: {
      arr: [
        // { name: 'Aviva Stadium, Lansdowne Road, Dublin 4', add: 'Aviva Stadium, Lansdowne Road, Dublin 4' },
        // { name: 'Leopardstown Golf Centre, Foxrock, Dublin', add: 'Leopardstown Golf Centre, Foxrock, Dublin' }
      ]
    },
    company: {
      arr: []
      // arr: [
      //   { name: "Ktech Security", img: "assets/images/ktech_logo.png", cname: "ktech" },
      //   { name: "Fitzer Catering", img: "assets/images/fitzer_logo.png", cname: "fitzer" }
      // ]
    },
    c_user: {
      arr: [
        {
          name: "Ktech Security", img: "", cname: "ktech",
          sub_a: [
            { s_n: "Vishva", e_i: 1, img: "" },
            { s_n: "Marcus Doe", e_i: 3, img: "" },
          ]
        },
        {
          name: "Fitzer Catering", img: "", cname: "fitzer", sub_a: [
            { s_n: "Krishna", e_i: 2, img: "" },
            { s_n: "Hiren Patel", e_i: 4, img: "" },
          ]
        },
      ]
    },
    c_category: {
      arr: [
        {
          name: "Ktech Security", img: "", cname: "ktech",
          sub_a: [
            {
              s_n: 'Kitchen Porter',
              j_sc_id: 11
            },
            {
              s_n: 'Relief Chef',
              j_sc_id: 12
            },
          ]
        },
        {
          name: "Fitzer Catering", img: "", cname: "fitzer", sub_a: [
            {
              s_n: 'Bar Staff',
              j_sc_id: 21
            },
            {
              s_n: 'Barista',
              j_sc_id: 22
            },
            {
              s_n: 'Waiting Staff',
              j_sc_id: 23
            },
          ]
        },
      ]
    }
  }
  currentDragPosition = { x: 0, y: 0 };
  @ViewChild('shiftContainer', { static: false }) shiftContainer!: ElementRef;

  public isViewByClick: boolean = false;
  public isAddOption: boolean = false;
  public isActionClick: boolean = false;

  hoverContent: any = '';
  private hoverTimeout: any;
  @ViewChild('hoverDiv') hoverDiv!: ElementRef;
  @ViewChild('weekDiv') weekDiv!: ElementRef;
  @ViewChild('templateDiv') templateDiv!: ElementRef;

  public viewByArr: any[] = [
    { name: "Company & User", value: "c_user", iconType: "img", img: "assets/images/icons/job_icon.svg", viewType: ['week'], userType: ['recruiter', 'admin'] },
    { name: "Company & Category", value: "c_category", iconType: "img", img: "assets/images/icons/job_icon.svg", viewType: ['week'], userType: ['recruiter', 'admin'], },
    { name: "Company", value: "company", iconType: "img", img: "assets/images/icons/user_icon.svg", viewType: ['week', 'day'], userType: ['recruiter', 'admin'], },
    { name: "Category", value: "category", iconType: "img", img: "assets/images/icons/job_icon.svg", viewType: ['week'], userType: ['recruiter', 'company', 'admin'], },
    { name: "Location", value: "location", iconType: "img", img: "assets/images/icons/job_icon.svg", viewType: ['week', 'day'], userType: ['company', 'admin'], },
    { name: "User", value: "user", iconType: "img", img: "assets/images/icons/user_icon.svg", viewType: ['week', 'day'], userType: ['recruiter', 'company', 'admin'], },

  ]
  public actionObj = {
    month: [
      { name: "Copy previous month", value: "copy" },
      { name: "Clear month", value: "clear" },
      // { name: "Unpublish month" },
      { name: "Unassign month", value: "unassign" },
      { name: "Export month", value: "export" },
    ],
    week: [
      { name: "Copy previous week", value: "copy" },
      { name: "Clear week", value: "clear" },
      // { name: "Unpublish week" },
      { name: "Unassign week", value: "unassign" },
      { name: "Export week", value: "export" },
    ],
    day: [
      { name: "Copy previous day", value: "copy" },
      { name: "Clear day", value: "clear" },
      // { name: "Unpublish day" },
      { name: "Unassign day", value: "unassign" },
      { name: "Export day", value: "export" },
    ]
  }
  public isDraggingEnabled: boolean = false;

  positionStyles = { top: '0px', left: '0px' };
  public isWeeklyTotals: boolean = false;
  public isDailyTotals: boolean = false;
  public isMinimizedView: boolean = false;
  public isMinimizedView2: boolean = false;
  public isFilterShow: boolean = false;
  public isShowAvailStatus: boolean = false
  public filterArr: any[] = [
    { key_name: "Location", key_val: "name", type: 'select', value: this.locArr, isCustomArray: true, field_name: "add" },
    { key_name: "Employee", key_val: "em_i", type: 'select', value: this.userArr, isCustomArray: true, field_name: "em_i" },
    { key_name: "Company", key_val: "id", type: 'select', value: this.companyArr, isCustomArray: true, field_name: "co_i" },
    { key_name: "Category", key_val: "j_c", type: 'select', value: this.categoryArr, isCustomArray: true, isSubArr: true, sub_item: "j_sc_id", field_name: "j_c" },
  ]
  public filterObj: Filter = {
    operand: "or",
    arr: []
  }
  public flags: Flags = {
    isViewByClick: false,
    isAddOption: false,
    isActionClick: false,
    isDraggingEnabled: false,
    isDayViewDetailHover: false,
  };
  public idArr = ['show-more', 'template-box'];
  focusedIndex: number | null | string = null;
  addBoxVisibleIndex: number | null = null;
  focusIndexWeek = {
    i: null,
    j: null,
    name: null,
  }

  public displayedColumns: string[] = ['first_name', 'job_name', 'address', 'category', 'time', 'charges', 'status', 'action'];
  public dataSource = new MatTableDataSource();
  public dataSourceNotClock = new MatTableDataSource();
  public count!: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  public userType: any;
  public currentTab: string = 'working_emp';
  public employeeStatus: any[] = [
    { name: "Mark as absent", value: "0" },
    { name: "Mark as early", value: "1" },
    { name: "Mark as late", value: "2" },
    { name: "Mark as sick", value: "3" },
  ]
  private weekClickListener?: () => void;
  public totalUnassignedShift!: number;

  public unavailabilityArr: any[] = []
  public templateArr: any[] = [];
  public maxWeekViewWidth = 117;
  isAdmin: boolean = false
  public startDate: any;
  public endDate: any;
  public isLoading = false;

  constructor(private elRef: ElementRef, private cd: ChangeDetectorRef, private activatedRoute: ActivatedRoute, private router: Router,
    private recruiterService: RecruiterService, private appService: AppService, private jobService: JobService,
    @Inject(DOCUMENT) private document: Document, private dialog: MatDialog, private commonService: CommonService, private renderer: Renderer2,
    private spinner: NgxSpinnerService, private filterEventPipe: FilterEventsPipe, private cookieService: CookieService) { }

  ngOnInit(): void {

    if (this.cookieService.get('user_id') && window.location.href.includes('iframe-job-call')) {
      // if (this.cookieService.get('user_id') && window.location.href.includes('iframe')) {
      // whenever admin user set the token of admin 
      this.appService.storeData('training-portal.admin-authToken', this.cookieService.get('user_id'));
      this.appService.storeSessionData('isAdmin', JSON.stringify(true));
      this.isAdmin = true;
      this.userType = "admin"
    }
    else {
      const userInfoStr = this.appService.getData('training-portal.userInfo');
      var userInfo;

      if (userInfoStr) {
        userInfo = JSON.parse(userInfoStr);
      }

      if (userInfo?.u_typ == 0) {
        this.userType = "company";
      }
      else if (userInfo?.u_typ == 1) {
        this.userType = "recruiter";
      } else if (userInfo?.u_typ == 3) {
        this.userType = "admin"
      }
      this.isAdmin = false;
    }
    this.viewByArr = this.viewByArr.filter(item => { return item.userType.includes(this.userType) })
    this.addArr = this.addArr.filter(item => { return item.userType.includes(this.userType) })


    setTimeout(() => { hoverJS() }, 200)
    this.commonService.setTitle("Job Scheduler")
    this.currentMonth = new Date();
    this.currentWeek = new Date();
    this.currentDate = new Date();
    // this.jobData = this.jobData.map(item => this.addShiftToTimeSeries(item))


    // this.generateDayView()
    this.filteredJobData.map((item, i) => {
      item["index"] = i
    });

    this.renderer.addClass(this.document.body, 'navs');

    // for week view you can add the shift using templates
    this.getTemplateList()
    this.generateMonthView();

    // this.getList();
    // this.getSchedulerSetupData();
    this.getList2();

  }

  // Code to generate custom calendar and its different views
  toggleView(mode): void {
    this.viewMode = mode.value;
    this.viewType = '';
    this.viewType = this.viewMode;

    // this.viewMode = mode;
    // detach the click listener if user is in the day or month view 
    // detaching is done from 2 points here and in the ngOnDestroy
    if (this.weekClickListener) {
      document.removeEventListener('click', this.weekClickListener);
    }
    if (this.viewMode === 'month') {
      this.generateMonthView();
    }
    else if (this.viewMode === 'week') {
      // attach Click Listener if it is week view this is used to hide the customized modals opened up
      // this.currentWeek = startOfWeek(startOfMonth(this.currentMonth), { weekStartsOn: 0 });
      this.currentWeek = startOfWeek(new Date(), { weekStartsOn: 0 });
      this.generateWeekView();
      // if it is week view then attach the click event and hide function 
      this.weekClickListener = this.hideTemplate.bind(this);
      document.addEventListener('click', this.weekClickListener);
      this.getweekCounting()
    }
    else if (this.viewMode === 'day') {
      // if (this.viewType === 'week') {
      //   this.currentDate = startOfWeek(this.currentWeek);
      // } else {
      //   this.currentDate = startOfMonth(this.currentMonth);
      // }
      this.currentDate = new Date()
      this.generateDayView();
    }
    // have commented this getList() as otherwise when changing the view then this getList() was getting called twice 
    // this i am uncommenting as now the getList() is not getting called twice,
    this.getList2()
  }
  getFirstDayOfMonth(): Date {
    return startOfWeek(startOfMonth(this.currentMonth), { weekStartsOn: 0 }); // Method to get the starting day of the week for the first day of the month
  }
  getDayOfWeek(date: Date): number { // Method to get the day of the week for each date
    return getDay(date);
  }
  getDayLabel(day: Date): string {
    return format(day, 'd');
  }
  generateMonthView(): void {
    const start = startOfMonth(this.currentMonth);
    const end = endOfMonth(this.currentMonth);
    const days = eachDayOfInterval({ start, end });
    this.daysInMonth = days.map(day => ({
      date: day,
      isCurrentMonth: true,
      events: this.filteredJobData.filter(job => isSameDay(parseISO(job.st_dt), day)),
      expanded: false,
      fDate: this.formatDate(day),
      isToday: isSameDay(day, new Date()),
      unav: this.unavailabilityArr.filter(job => isSameDay(parseISO(job.st_dt), day)),
    }));
    // Add days from the previous month to fill the first week
    let firstDayOfWeek = getDay(start);
    firstDayOfWeek = (firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1) as 0 | 1 | 2 | 3 | 4 | 5 | 6; //here we set monday as weeks first day

    if (firstDayOfWeek > 0) {
      const daysFromPrevMonth = eachDayOfInterval({
        start: subDays(start, firstDayOfWeek),
        end: subDays(start, 1)
      }).map(day => ({
        date: day,
        isCurrentMonth: false,
        events: this.filteredJobData.filter(job => isSameDay(parseISO(job.st_dt), day)),
        expanded: false,
        fDate: this.formatDate(day),
        isToday: false,
        unav: this.unavailabilityArr.filter(job => isSameDay(parseISO(job.st_dt), day)),
      }));
      this.daysInMonth = [...daysFromPrevMonth, ...this.daysInMonth];
    }
    // Add days from the next month to fill the last week
    // const lastDayOfWeek = getDay(end);
    let lastDayOfWeek = getDay(end);
    lastDayOfWeek = (lastDayOfWeek === 0 ? 6 : lastDayOfWeek - 1) as 0 | 1 | 2 | 3 | 4 | 5 | 6; //we set monday as weeks first day so we have to add last days of week 

    if (lastDayOfWeek < 6) {
      const daysFromNextMonth = eachDayOfInterval({
        start: addDays(end, 1),
        end: addDays(end, 6 - lastDayOfWeek)
      }).map(day => ({
        date: day,
        isCurrentMonth: false,
        events: this.filteredJobData.filter(job => isSameDay(parseISO(job.st_dt), day)),
        expanded: false,
        fDate: this.formatDate(day),
        isToday: false,
        unav: this.unavailabilityArr.filter(job => isSameDay(parseISO(job.st_dt), day)),
      }));
      this.daysInMonth = [...this.daysInMonth, ...daysFromNextMonth];
    }
  }
  generateWeekView(): void {
    this.currentMonth = startOfMonth(this.currentWeek);
    const start = startOfWeek(this.currentWeek, { weekStartsOn: 1 }); //here we set monday as weeks first day 
    const end = endOfWeek(this.currentWeek, { weekStartsOn: 1 }); //here we set monday as weeks first day
    const days = eachDayOfInterval({ start, end });

    this.daysInWeek = days.map(day => ({
      fDate: this.formatDate(day),
      date: day,
      day: format(day, 'd'),
      month: format(day, 'MMM'),
      dayOfWeek: format(day, 'EEE'),
      events: [],
      // events: this.filteredJobData.filter(job => isSameDay(parseISO(job.st_dt), day)),
      expanded: false,
      unav: this.unavailabilityArr.filter(job => isSameDay(parseISO(job.st_dt), day)),
      counting: {
        day_t_sh: 0,
        day_w_sh: 0,
        per: 0
      },
    }));
    this.weekHeader = `${format(start, 'MMM d')} - ${format(end, 'd')}`;
    this.viewTypeArr = [...this.viewByObj[this.viewBy].arr];
    this.expandedState = this.viewTypeArr.map(() => true);

  }
  generateDayView(): void {
    // same function is used in the generateDay View and then updateJobData
    setTimeout(() => {
      if (this.shiftContainer && this.shiftContainer.nativeElement) {
        const width = this.shiftContainer.nativeElement.offsetWidth;
        let bWidth = width / 24;
        // if (bWidth > 42) {
        //   this.boxWidth = (width / 24);
        // }
        // else {
        this.boxWidth = 42;
        // }
      }
    }, 100)
    // this.filteredJobData = this.filteredJobData.map(item => this.addShiftToTimeSeries(item));
    this.daysInDay = {
      fDate: this.formatDate(this.currentDate),
      date: this.currentDate,
      day: format(this.currentDate, 'd'),
      month: format(this.currentDate, 'MMM'),
      dayOfWeek: format(this.currentDate, 'EEE'),
      events: this.filteredJobData.filter(job => isSameDay(parseISO(job.st_dt), this.currentDate)),
      expanded: false
    };
    if (this.daysInDay.events.length > 0) {
      this.daysInDay.events = this.daysInDay.events.map(item => this.addShiftToTimeSeries(item))
    }
    this.viewBy = 'user';
    this.onViewTypeChange('user');
  }
  onTodayClick() {
    if (this.viewMode == 'month') {
      this.currentMonth = new Date();
      this.generateMonthView();
      this.getList2();
    }
    else if (this.viewMode == 'week') {

      this.currentWeek = new Date();
      this.generateWeekView();
      this.getList2();
      this.getweekCounting()
    }
    else {
      this.currentDate = new Date();
      this.generateDayView();
      this.getList2();
    }
  }
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  prev(): void {
    this.viewType = 'prev'
    if (this.viewMode === 'month') {
      this.currentMonth = new Date(this.currentMonth.setMonth(this.currentMonth.getMonth() - 1));
      this.generateMonthView();
      this.getList2();
    } else if (this.viewMode === 'week') {
      this.currentWeek = subDays(startOfWeek(this.currentWeek), 7);
      this.generateWeekView();
      this.getList2()
      this.getMaxWidthForWeekBox()
      this.getweekCounting()
    }
    else if (this.viewMode === 'day') {
      this.currentDate = subDays(this.currentDate, 1);
      this.generateDayView();
      this.getList2();
    }
  }
  next(): void {
    this.viewType = 'next'
    if (this.viewMode === 'month') {
      this.currentMonth = new Date(this.currentMonth.setMonth(this.currentMonth.getMonth() + 1));
      this.generateMonthView();
      this.getList2();
    } else if (this.viewMode === 'week') {
      this.currentWeek = addDays(startOfWeek(this.currentWeek), 7);
      this.generateWeekView();
      this.getList2()
      this.getMaxWidthForWeekBox()
      this.getweekCounting()
    }
    else if (this.viewMode === 'day') {
      this.currentDate = addDays(this.currentDate, 1);
      this.generateDayView();
      this.getList2();
    }
  }
  // trackByFn(index: number, item: any): any {
  //   return item.id; // Use a unique identifier
  // }

  // Common code for all the views
  onViewTypeChange(event) {
    // let selectedValue = event.value;
    this.isViewByClick = false;
    let selectedValue = event;
    if (selectedValue == 'week') {
      this.getweekCounting()
    }
    if (selectedValue == 'list') {
      this.onListView()
    }
    else {
      this.viewBy = event;
      this.viewTypeArr = [];
      const originalArray = [...this.viewByObj[this.viewBy].arr]
      this.viewTypeArr = originalArray;
      // changing view was taking the time 
      this.viewTypeArr = originalArray.slice(0, 10); // Load first 10 items

      let index = 10;
      const interval = setInterval(() => {
        this.viewTypeArr.push(...originalArray.slice(index, index + 10));
        index += 10;
        if (index >= originalArray.length) clearInterval(interval);
      }, 200); // Load remaining items in batches every 200ms

    }
  }
  // Code for Month view
  toggleExpand(day: { date: Date, isCurrentMonth: boolean, events: any[], expanded: boolean }): void {
    day.expanded = !day.expanded;
  }
  async dropEvent(event: CdkDragDrop<any[]>, day: any) {

    const copiedObject = JSON.parse(JSON.stringify(event.item.data));
    // Await the API validation
    copiedObject["st_dt"] = day.fDate;
    const isValid = await this.onDropShiftAPI(copiedObject);
    // const isValid=true;
    // Proceed based on the result from the API
    if (isValid) {
      // Perform the drop logic here
      this.isDraggingEnabled = false;
      if (event.previousContainer === event.container) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else {
        transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
      }
      let data = event.item.data;
      data["st_dt"] = day.fDate;
    } else {
      // Handle the drop cancellation logic here    
    }
  }
  dragStarted(event: any) {
    this.isDraggingEnabled = true;
  }
  getEventsForDay(sval, events: any[]) {

    if (this.viewBy == "category") {
      events = events.filter((item) => { item.j_sc == sval.j_sc })

      return events
    }
    else {
      return
    }
  }
  // Code for Week view
  filterViewWeek(filterVal, eventVal) {

    if (this.viewBy == 'user') {
      if (filterVal.em_i == eventVal.em_i) {
        return true
      }
    }
    else if (this.viewBy == "location") {
      if (filterVal.name == eventVal.add) {
        return true
      }
    }
    else if (this.viewBy == "category") {
      // console.error('category');
      if (filterVal.s_n == eventVal.j_sc && filterVal.j_c == eventVal.j_c) {
        return true
      }
    }
    else if (this.viewBy == "company") {
      if (filterVal.company_name == eventVal.company_name) {
        return true
      }
    }
    else if (this.viewBy == "c_user") {
      if (filterVal.em_i == eventVal.em_i) {
        return true
      }
    }
    else if (this.viewBy == "c_category") {
      if (filterVal.j_sc == eventVal.j_sc) {
        return true
      }
    }
    return false;
  }
  cdropEvent(event: CdkDragDrop<any[]>, day: any, droppedData, mainData): void {
    // this is common function used to drag and drop for month and week view 
    let isOpenShift: boolean = false;
    // Below is the event in dropEvent API
    const dropContainerElement = event.container.element.nativeElement;

    let droppedItem = event.item.data;


    if (droppedItem.op_s == 1) {
      // if it is open shift
      isOpenShift = true;
    }
    const propertiesToUpdate = this.viewByOptions[this.viewBy];
    // Update item properties based on selected viewBy option


    if (propertiesToUpdate) {
      propertiesToUpdate.forEach(property => {

        droppedItem["t_em_i"] = 0;//byDefault its 0
        // Update item property if it exists
        if (droppedItem.hasOwnProperty(property)) {
          if (droppedData.hasOwnProperty(property)) {
            //  if view by user then don't change the employee id instead add the t_em_i 
            if (property == 'em_i' && this.viewBy == 'user') {
              droppedItem["t_em_i"] = droppedData["em_i"];
            }
            else {
              droppedItem[property] = droppedData[property];
            }
          } else {
            droppedItem[property] = droppedData[property];
            // if property was the address then the drag and drop was not working properly because in droppedItem the node name was 'add' whereas in the 
            //droppedData it is coming as the name hence have put here the if condition and applied the manual check.
            if (property == 'add') {
              droppedItem["add"] = droppedData["name"];
            }
            if (property == 'company_name') {
              if (mainData) {
                droppedItem["company_name"] = mainData["name"];
                droppedItem["co_i"] = mainData["id"];
              }
            }
            if (property == 'j_sc') {
              droppedItem["j_sc"] = droppedData["s_n"];
            }
          }
        }
      });
      if (this.viewBy == "company") {
        droppedItem["co_i"] = droppedData["id"];
      }
    }
    if (isOpenShift && (this.viewBy == 'user')) {

      let newArr: any[] = [];
      if (droppedItem["accepted_employees"]) {
        newArr = [...droppedItem["accepted_employees"]]
      }
      newArr.push(droppedData["em_i"])
      droppedItem["emp"] = newArr;
      // droppedItem["qty"]=droppedItem["qty"]-1;
    }
    droppedItem.st_dt = day.fDate
    //  droppedItem["j_sc_id"]=21
    this.dropEvent(event, day);
    //if it was viewBy user then it was not sending the correect values hence the addded below line for em_i
    droppedItem["em_i"] = droppedData["em_i"];

    var itemIndex = this.filteredJobData.findIndex((item) => item.ran_num === droppedItem.ran_num);
    if (itemIndex !== -1) {// Update the item in the array      
      this.filteredJobData[itemIndex] = { ...this.filteredJobData[itemIndex], ...droppedItem };
    }

    this.daysInWeek = this.daysInWeek.map((day: any) => ({
      ...day, // If day is an object, spread its existing properties
      events: this.filteredJobData.filter(job => isSameDay(parseISO(job.st_dt), day.date)),
    }));
    // this.dropEvent(clonedItem, day);// commenting for a while

  }
  getJobsForUser(em_i: number): JobData[] {
    return this.jobData.filter(job => job.em_i === em_i);
  }
  trackByFn(index: number, item: any): any {
    return item.em_i;
  }
  aonDrop(event: CdkDragDrop<JobData[]>, user: any) {
    if (event.previousContainer === event.container) {
      if (event.previousIndex === event.currentIndex) {
      } else {
        // Reorder within the same container
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

      }
    } else {
      // Transfer between containers
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
      // Update the e_i to match the new user
      const movedJob = event.container.data[event.currentIndex];
      movedJob.em_i = user.em_i;

    }
  }
  adropEvent(event: CdkDragDrop<any[]>, droppedData, index) {

    if (!this.isResizing) {
      var distanceX = event.distance.x + 5;
      let droppedItem = event.item.data;

      let leftPositon = parseFloat(droppedItem.left.slice(0, -2));
      var newLeftPosition = (leftPositon + distanceX);
      // instead of passing distance i am passing the newLeftPosition
      if (this.checkTimeIsNegative(newLeftPosition)) {
        return;
      }
      var width = droppedItem["width"]
      droppedItem = this.reverseShiftFromTimeSeries(newLeftPosition, width, droppedItem)
      if (event.previousContainer === event.container) {

        // this.cd.detectChanges()
      } else {
        // droppedItem["e_i"] = droppedData["e_i"]
        const propertiesToUpdate = this.viewByOptions[this.viewBy];
        // Update item properties based on selected viewBy option
        if (propertiesToUpdate) {
          propertiesToUpdate.forEach(property => {
            // Update item property if it exists
            if (droppedItem.hasOwnProperty(property)) {
              if (droppedData.hasOwnProperty(property)) {
                droppedItem[property] = droppedData[property]
              }
            } else {
              // droppedItem["email"] = droppedData["email"];
            }
          });
        }
        // moveItemInArray(event.container.data, event.previousIndex, event.currentIndex)
        // transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
      }
      moveItemInArray(this.filteredJobData, event.previousIndex, event.currentIndex)


      this.onDropShiftAPI(droppedItem)
      // this.swapElements(this.jobData,droppedItem["index"],index)
      // this.jobData[index]["index"]=droppedItem["index"]
    }
  }
  updateJobData() {
    if (this.viewMode == 'month') {
      this.daysInMonth = this.daysInMonth.map((day: any) => ({
        ...day,  // If day is an object, spread its existing properties
        events: this.filteredJobData.filter(job => isSameDay(parseISO(job.st_dt), day.date)),
      }));

    }
    else if (this.viewMode === 'week') {
      this.daysInWeek = this.daysInWeek.map((day: any) => ({
        ...day,  // If day is an object, spread its existing properties
        events: this.filteredJobData.filter(job => isSameDay(parseISO(job.st_dt), day.date)),
      }));

    }
    else {

      setTimeout(() => {
        // same function is used in the generateDay View and then updateJobData
        if (this.shiftContainer && this.shiftContainer.nativeElement) {
          const width = this.shiftContainer.nativeElement.offsetWidth;

          let bWidth = width / 24;
          this.boxWidth = 42;
          // }
          this.daysInDay.events = this.filteredJobData.filter(job => isSameDay(parseISO(job.st_dt), this.currentDate))
          if (this.daysInDay.events.length > 0) {
            this.daysInDay.events = this.daysInDay.events.map(item => this.addShiftToTimeSeries(item))

          }
        }
      }, 100)
    }
  }
  swapElements(array: any[], index1: number, index2: number): void {
    // Check if indices are within bounds of the array
    if (index1 < 0 || index1 >= array.length || index2 < 0 || index2 >= array.length) {
      console.error('Invalid indices for swapping.');
      return;
    }
    // Swap elements using array destructuring
    [array[index1], array[index2]] = [array[index2], array[index1]];
  }
  isTimeNegative(time) {
    // Split the time string into hours, minutes, and seconds
    const timeParts = time.split(':').map(Number);
    // Check if the first part (hours) is negative
    if (timeParts[0] < 0) {
      return true;
    }
    // If hours are zero, check minutes and seconds
    if (timeParts[0] === 0) {
      if (timeParts[1] < 0) {
        return true;
      }
      if (timeParts[1] === 0 && timeParts[2] < 0) {
        return true;
      }
    }
    // If none of the above conditions are met, return false
    return false;
  }
  onDragReleased(event: any, index): void {

    let item = event.source.data
    var cat, sub_category, date

    if (event.event) {

      if (event.event.srcElement.attributes.hasOwnProperty('cat')) {

        cat = event.event.srcElement.attributes.cat.value
        sub_category = event.event.srcElement.attributes.sub_c.value
        date = event.event.srcElement.attributes.date.value
        item["category"] = cat
        item["j_sc_id"] = sub_category
        item["st_dt"] = date

      }
      else {
        if (event.event.target.closest('.job-w')) {
          cat = event.event.target.closest('.job-w').getAttribute('cat')
          sub_category = date = event.event.target.closest('.job-w').getAttribute('sub_c')
          date = event.event.target.closest('.job-w').getAttribute('date')
          item["category"] = cat
          item["j_sc_id"] = sub_category
          item["st_dt"] = date
        }
      }
    }
    else {
      cat = event.event.target.closest('.job-w').getAttribute('cat')
      sub_category = date = event.event.target.closest('.job-w').getAttribute('sub_c')
      date = event.event.target.closest('.job-w').getAttribute('date')
      item["category"] = cat
      item["j_sc_id"] = sub_category
      item["st_dt"] = date
    }
    // manually detect the updated changes
    this.cd.detectChanges();
    // this.jobData.push(item)
  }
  // Code for Day view
  addDecimalTime(startTime, decimalTime) {
    // Split the start time into hours, minutes, and seconds
    const [startHours, startMinutes, startSeconds] = startTime.split(':').map(Number);
    // Convert the decimal time to hours and minutes
    const hoursToAdd = Math.floor(decimalTime);
    const minutesToAdd = Math.round((decimalTime - hoursToAdd) * 60);
    // Add the desired hours and minutes
    let newHours = startHours + hoursToAdd;
    let newMinutes = startMinutes + minutesToAdd;
    // Adjust minutes if it exceeds 60
    newHours += Math.floor(newMinutes / 60);
    newMinutes %= 60;
    // Format the result
    const formattedHours = newHours < 10 ? '0' + newHours : newHours;
    const formattedMinutes = newMinutes < 10 ? '0' + newMinutes : newMinutes;
    return `${formattedHours}:${formattedMinutes}`;
  }
  timeStringToFloat(time) {
    var hoursMinutes = time.split(/[.:]/);
    var hours = parseInt(hoursMinutes[0], 10);
    var minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
    return hours + minutes / 60;
  }
  floatToTimeString(floatTime) {
    var hours = Math.floor(floatTime); // Extract whole hours
    var minutes = Math.round((floatTime % 1) * 60); // Extract minutes from the decimal part and round
    // Format time string
    var timeString = hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':00';
    return timeString;
  }
  getEventTimeRange(startTime: number, endTime: number) {
    if (endTime < startTime || (endTime === startTime && endTime !== 0)) {
      // If the event crosses midnight, normalize endTime
      endTime += 24;
    }
    return endTime;
  }
  addShiftToTimeSeries(job_data: any) {
    var shiftStartTime = this.timeStringToFloat(job_data["st_ti"]);
    // if(job_data["ed_ti"]=="00:00:00"){
    //   var shiftEndTime = this.timeStringToFloat("23:59:59");
    // }
    // else{
    //   var shiftEndTime = this.timeStringToFloat(job_data["ed_ti"]);
    // }
    var shiftEndTime = this.timeStringToFloat(job_data["ed_ti"]);
    // var shiftEndTime = this.getEventTimeRange(shiftStartTime,this.timeStringToFloat(job_data["ed_ti"])) ;

    var shiftLeft = shiftStartTime * this.boxWidth;
    var shiftRight = shiftEndTime * this.boxWidth;
    var shiftWidth = Math.abs(shiftRight - shiftLeft);
    job_data["left"] = shiftLeft.toFixed(2) + 'px';
    job_data["width"] = shiftWidth.toFixed(2);

    return job_data;
  }
  reverseShiftFromTimeSeries(left, width, job_data: any) {
    var shiftLeft = parseFloat(left) / this.boxWidth;
    var shiftWidth = parseFloat(width) / this.boxWidth;
    var shiftStartTime = this.floatToTimeString(shiftLeft);
    var shiftEndTime = this.floatToTimeString(shiftLeft + shiftWidth);
    job_data["left"] = left + 'px';
    job_data["st_ti"] = shiftStartTime;
    job_data["ed_ti"] = shiftEndTime;
    return job_data;
  }
  checkTimeIsNegative(left) {
    var shiftLeft = parseFloat(left) / this.boxWidth;
    var shiftStartTime = this.floatToTimeString(shiftLeft);
    if (shiftStartTime.includes('-')) {
      return true;
    }
    else {
      return false;
    }
  }
  calcStartTimeFromPosition(start_time, distance) {
    var float_start_time = this.timeStringToFloat(start_time)
    var add_time = distance / this.boxWidth;
    var new_start_time = this.floatToTimeString(float_start_time + add_time)
    return new_start_time
  }
  calcEndTimeFromStartTime(start_time, width) {
    var shiftStartTime = this.timeStringToFloat(start_time)
    var hours = shiftStartTime + (width / this.boxWidth);
    var shiftEndTime = this.floatToTimeString(hours);
    return shiftEndTime
  }
  addDecimalHours(startTime, decimalHours) {
    // Parse the start time (assumes format "HH:MM:SS")
    let [startHours, startMinutes, startSeconds] = startTime.split(':').map(Number);
    // Separate the decimal hours into hours and minutes
    let fullHours = Math.floor(decimalHours);
    let fractionalHours = decimalHours - fullHours;
    let additionalMinutes = fractionalHours * 60;
    let additionalFullMinutes = Math.floor(additionalMinutes);
    let additionalSeconds = (additionalMinutes - additionalFullMinutes) * 60;
    // Add hours and minutes to the start time
    let newHours = startHours + fullHours;
    let newMinutes = startMinutes + additionalFullMinutes;
    let newSeconds = startSeconds + additionalSeconds;
    // Handle overflow of seconds to minutes
    if (newSeconds >= 60) {
      newMinutes += Math.floor(newSeconds / 60);
      newSeconds = newSeconds % 60;
    }
    // Handle overflow of minutes to hours
    if (newMinutes >= 60) {
      newHours += Math.floor(newMinutes / 60);
      newMinutes = newMinutes % 60;
    }
    // Handle overflow of hours beyond 24 (optional, depends on desired behavior)
    newHours = newHours % 24;
    // Format the new time to "HH:MM:SS"
    let formattedTime = [
      String(newHours).padStart(2, '0'),
      String(newMinutes).padStart(2, '0'),
      String(Math.floor(newSeconds)).padStart(2, '0')
    ].join(':');
    return formattedTime;
  }
  subtractDecimalHours(endTime, decimalHours) {
    // Parse the end time (assumes format "HH:MM:SS")
    let [endHours, endMinutes, endSeconds] = endTime.split(':').map(Number);

    // Separate the decimal hours into hours and minutes
    let fullHours = Math.floor(decimalHours);
    let fractionalHours = decimalHours - fullHours;
    let subtractMinutes = fractionalHours * 60;
    let subtractFullMinutes = Math.floor(subtractMinutes);
    let subtractSeconds = (subtractMinutes - subtractFullMinutes) * 60;
    // Subtract the hours and minutes from the end time
    let newHours = endHours - fullHours;
    let newMinutes = endMinutes - subtractFullMinutes;
    let newSeconds = endSeconds - subtractSeconds;
    // Handle underflow of seconds to minutes
    if (newSeconds < 0) {
      newMinutes -= 1;
      newSeconds += 60;
    }
    // Handle underflow of minutes to hours
    if (newMinutes < 0) {
      newHours -= 1;
      newMinutes += 60;
    }
    // Handle underflow of hours (to previous day if needed)
    if (newHours < 0) {
      newHours += 24;
    }
    // Format the new time to "HH:MM:SS"
    let formattedTime = [
      String(newHours).padStart(2, '0'),
      String(newMinutes).padStart(2, '0'),
      String(Math.floor(newSeconds)).padStart(2, '0')
    ].join(':');
    return formattedTime;
  }


  onMouseDown2(event: MouseEvent | TouchEvent, job: any, direction: any) {

    let clientX: number;

    if (event instanceof MouseEvent) {
      clientX = event.clientX;
    } else if (event instanceof TouchEvent && event.touches.length > 0) {
      clientX = event.touches[0].clientX;
    } else {
      return;
    }

    // return;
    this.isResizing = true;
    this.resizeDirection = direction;
    this.resizingJob = job;
    this.startX = clientX;
    this.startWidth = parseInt(job.width);
    this.startLeft = parseInt(job.left.toString());

    event.preventDefault();
  }

  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:touchmove', ['$event'])
  onMouseMove(event: MouseEvent | TouchEvent) {
    let clientX: number;

    if (event instanceof MouseEvent) {
      clientX = event.clientX;
    } else if (event instanceof TouchEvent && event.touches.length > 0) {
      clientX = event.touches[0].clientX;
    } else {
      return;
    }


    if (!this.isResizing || !this.resizeDirection || !this.resizingJob) return;
    let newWidth;
    if (this.resizeDirection === 'left') {
      newWidth = this.startWidth - (clientX - this.startX);
      if (newWidth > 50) {
        this.resizingJob.width = newWidth;
        const newLeft = this.startLeft + (clientX - this.startX);
        this.resizingJob.left = newLeft + "px";

        const hours = this.resizingJob.width / this.boxWidth;
        let end_time = this.timeStringToFloat(this.resizingJob.ed_ti).toFixed(2);
        let totalHours = Number(end_time) - Number(hours);
        if (Math.sign(totalHours) == -1) { return; }
        this.resizingJob.st_ti = this.floatToTimeString(totalHours);
      }
    } else if (this.resizeDirection === 'right') {
      newWidth = this.startWidth + (clientX - this.startX);
      if (newWidth > 50) {
        this.resizingJob.width = newWidth;
        const hours = this.resizingJob.width / this.boxWidth;
        let start_time = this.timeStringToFloat(this.resizingJob.st_ti).toFixed(2);
        let totalHours = Number(start_time) + Number(hours);
        this.resizingJob.ed_ti = this.floatToTimeString(totalHours);
      }
    }
  }

  @HostListener('document:mouseup')
  @HostListener('document:touchend')
  onMouseUp() {
    if (!this.isResizing) return;
    this.onDropShiftAPI(this.resizingJob)
    this.isResizing = false;
    this.resizeDirection = null;
    this.resizingJob = null;
  }

  onAddMultipleShift() {
    const dialogRef = this.dialog.open(AddMultipleShiftComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", width: '95%', height: '98%', maxWidth: '90vw'
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getList2();
    });
  }
  onClickViewBy(addType, event, date, mainItem, subItem) {

    let data = {
      viewType: this.viewBy,
      addType: "single",
      modalType: "add",
      // the type and pass values to it accordingly
      ...{
        category: { j_c: mainItem.name, j_sc: subItem.s_n },
        location: { add: mainItem.name },
        user: { em_i: mainItem.em_i },
        company: { co_i: mainItem.id }, //for company id 
        c_category: { co_i: mainItem.id, j_sc: subItem.j_sc, j_c: subItem.j_c },
        c_user: { co_i: mainItem.id, em_i: subItem.em_i },
      }[this.viewBy]
    };
    if (this.viewBy)
      this.onAddSingleShift(data, date)
  }
  onAddShift(addType, event, date) {
    let data = {
      addType: addType,
      modalType: "add",
      shift_data: "",
    }
    if (addType == 'open_shift') {
      data.addType = "single"
      data.modalType = "open_shift"
    }
    else if (addType == "add") {
      data.addType = "single"
      data.modalType = "add"
    }
    else if (addType == "edit") {
      data.addType = "single"
      if (event.op_s == 1) {
        data.modalType = "open_shift"
      }
      else {
        data.modalType = "edit"
      }
      data.shift_data = event
    }
    this.onAddSingleShift(data, date)
  }

  onAddSingleShift(dataObj: any, date) {

    let modalData = {
      date: date,
    }
    modalData = Object.assign(modalData, dataObj);
    const dialogRef = this.dialog.open(AddShiftComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      width: '98%', height: '98%',
      maxWidth: '700px',
      autoFocus: false,
      data: modalData
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {

      this.getList2();
    });
  }
  onAddRosterShift() {
    const dialogRef = this.dialog.open(RosterShiftComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", minWidth: '280px', width: '30%'
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  onFilterView() {
    this.isFilterShow = !this.isFilterShow;
  }
  onActionSelection(item) {
    if (item.value == 'export') {
      this.onExportSchedule()
    }
    else if (item.value == 'copy') {
      // let data = {
      //   type: "copy",
      //   view_type: this.viewMode,
      // }
      let startDate = this.formatDate(
        this.viewMode === 'month' ? startOfMonth(subMonths(this.currentMonth, 1)) :
          this.viewMode === 'week' ? startOfWeek(subWeeks(this.currentWeek, 1)) :
            subDays(this.currentDate, 1)
      );
      let endDate = this.formatDate(
        this.viewMode === 'month' ? endOfMonth(subMonths(this.currentMonth, 1)) :
          this.viewMode === 'week' ? endOfWeek(subWeeks(this.currentWeek, 1)) :
            subDays(this.currentDate, 1)
      );
      let data = {
        type: "copy",
        view_type: this.viewMode,
        reqObj: {
          "co_typ": this.viewMode === 'month' ? 0 : this.viewMode === 'week' ? 1 : 2,
          "c_st_dt": startDate,
        },
        totalShift: {
          st_dt: startDate,
          ed_dt: endDate
        },
      };
      this.getConfirmation(data)
    }
    else if (item.value == 'clear') {
      let startDate = this.formatDate(
        this.viewMode === 'month' ? startOfMonth(this.currentMonth) :
          this.viewMode === 'week' ? startOfWeek(this.currentWeek) :
            subDays(this.currentDate, 1)
      );
      let endDate = this.formatDate(
        this.viewMode === 'month' ? endOfMonth(this.currentMonth) :
          this.viewMode === 'week' ? endOfWeek(this.currentWeek) :
            this.currentDate
      );
      let data = {
        type: "clear",
        view_type: this.viewMode,
        reqObj: {
          "st_dt": startDate,
          "ed_dt": endDate,
          "del_t": "0",// 0= this shift 1= future shift 2=all this series.
          "sh_id": "",
          "comm_id": "",
        },
        totalShift: {
          st_dt: startDate,
          ed_dt: endDate
        },
      }
      this.getConfirmation(data)
    }
    else if (item.value == 'unassign') {
      this.onUnassignShift()
    } else if (item.value == 'export-pdf') {

    }
  }
  getConfirmation(data) {
    const dialogRef = this.dialog.open(RecConfirmModalComponent, {
      enterAnimationDuration: '300ms',
      exitAnimationDuration: "300ms",
      minWidth: '280px',
      maxWidth: '450px',
      height: 'auto',
      // minHeight:'200px'
      data: data,
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result && result.confirm == 'yes') {
        this.getList2()
      }
    });
  }
  onAddSelection(value) {

    // there are two things passed to this modal addType and modalType
    let data = {
      addType: "",
      modalType: "add",
    }
    this.isAddOption = false;
    if (value == 'single') {
      // here by multiple it means the ability to select multiple dates from the date  picker
      data.addType = "multiple",
        this.onAddSingleShift(data, '')
    }
    else if (value == 'instant_hire' || value == 'assign_employee' || value == 'assign_fav_employee') {
      data.addType = value
      this.onAddSingleShift(data, '')
    }
    else if (value == 'additional_resource') {
      data.addType = value
      this.getRecruiterList(data)
    }
    else if (value == 'multiple') {
      this.onAddMultipleShift()
    }
    else if (value == 'csv') {
      this.onImportCSV()
    }
    else if (value == 'roster') {
      this.onAddRosterShift()
    }
    else {

    }
  }

  getRecruiterList(uData: any) {
    const data = {}
    this.spinner.show()
    this.jobService.recruiterList(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success["status"] == 200) {
          this.recruiterArr = [...(success["data"])];
          this.filterRecArr = [...this.recruiterArr];
          this.onAddSingleShift(uData, '')
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);

      },
    });
  }
  onImportCSV() {
    const dialogRef = this.dialog.open(ImportShiftCsvComponent, {
      width: '80%',
      minWidth: '300px',
      height: '98%',
      maxHeight: '690px', maxWidth: '800px',
      autoFocus: false,
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
  onListView() {
    const dialogRef = this.dialog.open(NewListViewComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", width: '95%', height: '98%', maxWidth: '90vw'
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {

    });
    // const dialogRef = this.dialog.open(ListViewComponent, {
    //   enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", width: '95%', height: '98%', maxWidth: '90vw'
    //   // minHeight:'200px'
    // });
    // dialogRef.afterClosed().subscribe(result => {
    // 
    // });
  }
  onCostCalc() {
    const dialogRef = this.dialog.open(CountWagesComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", width: '60%', height: 'auto', maxWidth: '600px', minWidth: '280px',
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  onSettings() {
    const dialogRef = this.dialog.open(JobSchedulingSettingsComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", width: '95%', height: '98%', maxWidth: '90vw'
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {

    });
    // const dialogRef = this.dialog.open(ScheduleShiftConfirmationComponent, {
    //   enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", minWidth: '280px', maxWidth: '380px', height: 'auto'
    //   // minHeight:'200px'
    // });
    // dialogRef.afterClosed().subscribe(result => {

    // });
    // const dialogRef = this.dialog.open(RecConfirmModalComponent, {
    //   enterAnimationDuration: '300ms', exitA nimationDuration: "300ms", minWidth: '280px', maxWidth: '450px', height: 'auto'
    //   // minHeight:'200px'
    // });
    // dialogRef.afterClosed().subscribe(result => {

    // });
  }
  onViewByClick() {
    this.isViewByClick = !this.isViewByClick
  }
  onAddOption() {
    this.isAddOption = !this.isAddOption;
  }
  onActionClick() {
    this.isActionClick = !this.isActionClick;
  }
  getActionItems() {
    return this.actionObj[this.viewMode]
  }
  // onHover(event: MouseEvent, index: number | string, data: any) {
  //   if (this.isDraggingEnabled) { return }
  //   for (const item of this.idArr) {
  //     if (document.getElementById(item)?.classList.contains('d-block')) {
  //       return; // Exit the onHover function if the condition is met
  //     }
  //   }
  //   if (!this.isDraggingEnabled) {
  //     clearTimeout(this.hoverTimeout); // Clear any existing timeout
  //     const target = event.target as HTMLElement;
  //     const rect = target.getBoundingClientRect();
  //     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  //     const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  //     const hoverDiv = this.hoverDiv.nativeElement;

  //     this.hoverContent = data;// Set the content based on the hovered item
  //     this.renderer.setStyle(hoverDiv, 'top', `${rect.bottom + scrollTop}px`);
  //     this.renderer.setStyle(hoverDiv, 'left', `${rect.left + scrollLeft}px`);
  //     this.renderer.setStyle(hoverDiv, 'display', 'block');
  //   }
  // }
  onHover(event: MouseEvent, index: number | string, data: any) {
    if (this.isDraggingEnabled) return;

    for (const item of this.idArr) {
      if (document.getElementById(item)?.classList.contains('d-block')) {
        return;
      }
    }

    clearTimeout(this.hoverTimeout); // Clear any existing timeout

    // Try to find nearest .job-item related to the hovered element
    let jobItemElement = (event.target as HTMLElement).closest('.job-item') as HTMLElement;

    // Optional fallback: if not found in ancestors, try searching among siblings or parents
    if (!jobItemElement) {
      jobItemElement = (event.target as HTMLElement).parentElement?.querySelector('.job-item') as HTMLElement;
    }

    if (!jobItemElement) return; // Don't show hover if we can't find the reference element

    const rect = jobItemElement.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const hoverDiv = this.hoverDiv.nativeElement;

    this.hoverContent = data;


    // Position the hoverDiv just below and aligned to the left of the .job-item
    this.renderer.setStyle(hoverDiv, 'top', `${rect.bottom + scrollTop + 7}px`);
    this.renderer.setStyle(hoverDiv, 'left', `${rect.left + scrollLeft}px`);
    this.renderer.setStyle(hoverDiv, 'display', 'block');
  }

  // onHover(event: MouseEvent, index: number | string, data: any) {
  //   if (this.isDraggingEnabled) return;

  //   for (const item of this.idArr) {
  //     if (document.getElementById(item)?.classList.contains('d-block')) {
  //       return;
  //     }
  //   }

  //   clearTimeout(this.hoverTimeout);

  //   let jobItemElement = (event.target as HTMLElement).closest('.job-item') as HTMLElement;
  //   if (!jobItemElement) {
  //     jobItemElement = (event.target as HTMLElement).parentElement?.querySelector('.job-item') as HTMLElement;
  //   }
  //   if (!jobItemElement) return;

  //   const rect = jobItemElement.getBoundingClientRect();
  //   const hoverDiv = this.hoverDiv.nativeElement;
  //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  //   const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

  //   this.hoverContent = data;

  //   // Calculate initial position
  //   let top = rect.bottom + scrollTop;
  //   let left = rect.left + scrollLeft;

  //   // Get hover div size (after setting content, ideally wait for DOM update)
  //   hoverDiv.style.display = 'block'; // Temporarily display it to get dimensions
  //   const hoverWidth = hoverDiv.offsetWidth;
  //   const hoverHeight = hoverDiv.offsetHeight;

  //   const viewportWidth = window.innerWidth;
  //   const viewportHeight = window.innerHeight;

  //   // Adjust horizontal position if overflowing right
  //   if (left + hoverWidth > scrollLeft + viewportWidth) {
  //     left = scrollLeft + viewportWidth - hoverWidth - 10; // Add some padding
  //   }
  //   left = Math.max(left, scrollLeft + 10); // Don't go off to the left

  //   // Adjust vertical position if overflowing bottom
  //   if (top + hoverHeight > scrollTop + viewportHeight) {
  //     top = rect.top + scrollTop - hoverHeight - 10; // Show above the element
  //   }
  //   top = Math.max(top, scrollTop + 10); // Don't go off the top

  //   // Set position
  //   this.renderer.setStyle(hoverDiv, 'top', `${top}px`);
  //   this.renderer.setStyle(hoverDiv, 'left', `${left}px`);
  //   this.renderer.setStyle(hoverDiv, 'display', 'block');
  // }


  onHoverOut() {
    // Add a small delay before hiding the element
    this.hoverTimeout = setTimeout(() => {
      this.renderer.setStyle(this.hoverDiv.nativeElement, 'display', 'none');
    }, 200); // Adjust the delay as needed
  }
  onWeekHoverOut() {
    if (this.weekDiv?.nativeElement) {
      this.renderer.setStyle(this.weekDiv.nativeElement, 'display', 'none');
    }
  }
  getColorsFromArray(index) {
    // this function is used to have custom background colors.
    // let colorsArr: string[] = ['rgba(232, 249, 247, 1)', 'rgba(252, 246, 255, 1)', 'rgba(249, 244, 232, 1)',]
    let colorsArr: string[] = ['rgba(255, 187, 158, 1)', 'rgba(141, 255, 244, 1)', 'rgba(255, 217, 146, 1)', 'rgba(198, 188, 255, 1)']
    const color = colorsArr[index % colorsArr.length];
    return color
  }
  isValidViewMode(item) {
    return item?.viewType?.includes(this.viewMode)
  }
  getTrimmedData(value: any) {
    let sentence = value.start_time.slice(0, 5) + "-" + value.end_time.slice(0, 5) + " " + value.first_name;
    if (sentence.length > 20) {
      const trimmedSentence = sentence.slice(0, 25); //
      return trimmedSentence + '..'
    }
    return sentence;
  }
  getTrimmedTime(time) {
    const trimmedTime = time.slice(0, 5); //
    return trimmedTime
  }
  getFullName(first_name, last_name) {
    return this.getTrimmedTitle(first_name + " " + last_name);
  }
  getTrimmedTitle(name: string) {
    if (name && name.length > 20) {
      const trimmedTitle = name.slice(0, 20); //
      return trimmedTitle + '...'
    }
    return name
  }
  onAvaliStatus(event) {
    this.isShowAvailStatus = event.checked;
    this.generateMonthView();

  }
  onWeeklyTotal(event) {
    this.isWeeklyTotals = event.checked;
  }
  onDailyTotal(event) {
    this.isDailyTotals = event.checked;
  }
  onMinimizeView() {
    this.isMinimizedView = !this.isMinimizedView;
  }
  // ============================================================Filter Object/Array and logic =====================================
  callApi(obj) {
    this.filterObj = obj;
    // if (this.filterObj.arr.length == 0) {
    //   this.filteredJobData = [...this.jobData];
    // }
    // else {
    //   this.filteredJobData = this.filterJobs([...this.jobData], this.filterObj);
    // }
    // if (this.viewMode == 'month') {
    //   this.generateMonthView();
    // }
    // else if (this.viewMode == 'week') {
    //   this.generateWeekView();
    // }
    // else {
    //   this.generateDayView();
    // }
    this.getList2()
    this.getSchedulerSetupData()
  }
  filterJobs(jobs: JobData[], filter: Filter): JobData[] {
    if (filter.operand === 'or') {
      return jobs.filter(job => filter.arr.some(f => this.matchesFilter(job, f)));
    } else if (filter.operand === 'and') {
      return jobs.filter(job => filter.arr.every(f => this.matchesFilter(job, f)));
    } else {
      return jobs;
    }
  }
  matchesFilter(job: JobData, filterDetail: any): boolean {
    if (filterDetail.contains === 'is') {
      if (filterDetail.hasOwnProperty('sub_val') && filterDetail.sub_val != '') {
        return (job[filterDetail.filter_value] === filterDetail.type_value) && (job[filterDetail.sub_item] === filterDetail.sub_val);
      }
      else {
        return job[filterDetail.filter_value] === filterDetail.type_value;
      }
    }
    else if (filterDetail.contains == 'is not') {
      if (filterDetail.hasOwnProperty('sub_val') && filterDetail.sub_val != '') {
        return ((job[filterDetail.sub_item] != filterDetail.sub_val));
      }
      else {
        return job[filterDetail.filter_value] != filterDetail.type_value;
      }
    }
    else {
      return false;
    }
  }
  // =========================================================================================================================
  onMoreClick(event, data) {
    event.stopPropagation(); //

    this.showCustomModal(event, 'show-more', data, 209)
  }
  onSelectTemplate(event) {
    event.stopPropagation();
    const clickedElement = event.target as HTMLElement;
    // this is the add box it contains the add shift and add template options 
    const allAddBox = document.querySelectorAll('.ad-box')
    allAddBox.forEach((item) => {
      if (item.classList.contains('d-flex')) {
        item.classList.remove('d-flex')
      }
    })
    // Find the closest ancestor with an ID
    const closestElementWithId = clickedElement.closest('[id]') as HTMLElement;
    const adElement = closestElementWithId.querySelector('.ad-box') as HTMLElement;
    adElement.classList.add('d-flex');

    this.showCustomModal(event, 'template-box', '', 216)
  }
  showCustomModal(event, idName, data, width) {
    // if any other previous modal is open then close all of them and open the one which is clicked
    this.idArr.forEach((item) => {
      // Get the element by ID
      let element = document.getElementById(item);
      // Check if the element exists and its ID does not match idName
      if (element && item !== idName) {
        element.classList.remove('d-block');
      }
    });

    const target = event.target as HTMLElement;
    const rect = target.getBoundingClientRect();

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    this.hoverContent = data;// Set the content based on the hovered item
    this.positionStyles.top = `${rect.bottom + scrollTop - 27}px`;
    this.positionStyles.left = `${rect.left + scrollLeft + 15}px`;

    let newLeft = rect.left + scrollLeft + 15 + width;
    if (newLeft > window.innerWidth) {
      newLeft = window.innerWidth - (width + 15);
      this.positionStyles.left = newLeft + 'px'
    }
    // const clickedElement = event.target as HTMLElement;
    const elementToAttach = document.getElementById(idName);
    if (elementToAttach) {
      elementToAttach.classList.toggle('d-block')
    }
  }
  hideTemplate() {
    const allAddBox = document.querySelectorAll('.ad-box')
    allAddBox.forEach((item) => {
      if (item.classList.contains('d-flex')) {
        item.classList.remove('d-flex')
      }
    })
    this.idArr.forEach((item) => {
      // Get the element by ID
      let element = document.getElementById(item);
      // Check if the element exists and its ID does not match idName
      if (element) {
        element.classList.remove('d-block');
      }
    });
  }
  onWeekDayHover(index: number) {
    this.focusedIndex = index;
  }
  onWeekDayHoverOut(index: number) {
    if (this.addBoxVisibleIndex !== index) {
      this.focusedIndex = null;
    }
  }
  // ===========================================Filter logic end here========================================
  // ===========================================Unavailability
  onAddUnavailability() {
    const dialogRef = this.dialog.open(AddUnavailabilityComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", minWidth: '300px', width: '50%'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }
  onViewUnavailability(unArr) {
    const dialogRef = this.dialog.open(ViewUnavailabilityComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      minWidth: '300px', width: '50%', maxWidth: '650px', maxHeight: "600px", height: "90%",
      // data: this.unavailabilityArr //changed by ankush
      data: unArr,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }
  // ======================================on EXPORTING SCHEDULER===
  onExportSchedule() {
    let startDate = this.formatDate(
      this.viewMode === 'month' ? startOfMonth(this.currentMonth) :
        this.viewMode === 'week' ? startOfWeek(this.currentWeek) :
          this.currentDate
    );
    let endDate = this.formatDate(
      this.viewMode === 'month' ? endOfMonth(this.currentMonth) :
        this.viewMode === 'week' ? endOfWeek(this.currentWeek) :
          this.currentDate
    );
    const data = {
      "st_dt": startDate,
      "ed_dt": endDate,
    }
    this.spinner.show()
    this.recruiterService.exportSchedule(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.spinner.hide()
          this.appService.downloadFile(success.sheet, 'month')
          // this.isSpinnerLoading=false
        }
      },
      error: (error: any) => {
        this.spinner.hide()
        this.commonService.handleError(error);
      },
    });
  }


  getList2() {
    this.getSchedulerSetupData();

    this.isLoading = true;
    let newArr: any[] = this.filterObj.arr;
    for (let i = 0; i < newArr.length; i++) {
      delete newArr[i]["key_name"]
      delete newArr[i]["arr"]
      //if(newArr[i]["key_name"]){}
      newArr[i]["filter_value"] = newArr[i]["field_name"]
      // delete newArr[i]["field_name"] // ankush commented this because its making issue when we change previous and next (month day and week) 
    }
    let data = {
      "st": "0",
      "r_p": "10",
      "v_t": "employee",
      f_a: newArr,
      op_nd: this.filterObj.operand
    }

    if (this.viewMode == 'month') {
      data["st_dt"] = this.daysInMonth[0]["fDate"]
      data["ed_dt"] = this.daysInMonth[this.daysInMonth.length - 1]["fDate"]

      this.startDate = this.daysInMonth[0]['fDate']
      this.endDate = this.daysInMonth[this.daysInMonth.length - 1]["fDate"]
    }
    else if (this.viewMode == 'week') {
      data["st_dt"] = this.daysInWeek[0]["fDate"]
      data["ed_dt"] = this.daysInWeek[this.daysInWeek.length - 1]["fDate"]

      this.startDate = this.daysInWeek[0]["fDate"]
      this.endDate = this.daysInWeek[this.daysInWeek.length - 1]["fDate"]
    }
    else {
      data["st_dt"] = this.daysInDay["fDate"]
      data["ed_dt"] = this.daysInDay["fDate"]

      this.startDate = this.daysInDay["fDate"]
      this.endDate = this.daysInDay["fDate"]
    }

    this.jobService.getOnlyJobData(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.isLoading = false;
          this.jobData = []
          this.jobData = success.msg["j_d"]
          this.totalUnassignedShift = this.jobData.filter(item => item.op_s === 1).length;

          // this.filteredJobData = [...this.jobData]
          this.filteredJobData = JSON.parse(JSON.stringify(this.jobData))
          this.updateJobData();

          this.getUnavailability(data)
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        this.commonService.handleError(error);
      },
    });
  }
  getSchedulerSetupData() {
    let newArr: any[] = this.filterObj.arr;
    for (let i = 0; i < newArr.length; i++) {
      delete newArr[i]["key_name"]
      delete newArr[i]["arr"]
      //if(newArr[i]["key_name"]){}
      newArr[i]["filter_value"] = newArr[i]["field_name"]
      // delete newArr[i]["field_name"] // ankush commented this because its making issue when we change previous and next (month day and week) 
    }

    let data = {
      "st": "0",
      "r_p": "10",
      "v_t": "employee",
      f_a: newArr,
      op_nd: this.filterObj.operand
    }

    if (this.viewMode == 'month') {
      data["st_dt"] = this.daysInMonth[0]["fDate"]
      data["ed_dt"] = this.daysInMonth[this.daysInMonth.length - 1]["fDate"]

      this.startDate = this.daysInMonth[0]['fDate']
      this.endDate = this.daysInMonth[this.daysInMonth.length - 1]["fDate"]
    }
    else if (this.viewMode == 'week') {
      data["st_dt"] = this.daysInWeek[0]["fDate"]
      data["ed_dt"] = this.daysInWeek[this.daysInWeek.length - 1]["fDate"]

      this.startDate = this.daysInWeek[0]["fDate"]
      this.endDate = this.daysInWeek[this.daysInWeek.length - 1]["fDate"]
    }
    else {
      data["st_dt"] = this.daysInDay["fDate"]
      data["ed_dt"] = this.daysInDay["fDate"]

      this.startDate = this.daysInDay["fDate"]
      this.endDate = this.daysInDay["fDate"]
    }

    this.jobService.getSchedulerSetupDate(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {

          this.viewByObj.category.arr = success["category"].map((e) => {
            return {
              ...e,
              j_c: e.name
            }
          });

          //firts clear all data
          this.viewByObj.location.arr = [];
          this.viewByObj.user.arr = [];
          this.viewByObj.company.arr = [];
          this.viewByObj.c_category.arr = [];

          this.viewByObj.location.arr = success['locations'].flatMap((locObj: any) => locObj.location);
          localStorage.setItem('filterLocations', JSON.stringify(this.viewByObj.location.arr));

          this.viewByObj.user.arr = success["employees"];
          this.viewByObj.company.arr = success["companies"];
          this.viewByObj.c_category.arr = success["companies"];

          for (let i = 0; i < this.filterArr.length; i++) {
            if (this.filterArr[i]['key_name'] == "Location") {
              this.filterArr[i]["value"] = this.viewByObj.location.arr;
            }
            if (this.filterArr[i]['key_name'] == "Company") {
              this.filterArr[i]["value"] = this.viewByObj.company.arr;
            }
            if (this.filterArr[i]['key_name'] == "Category") {
              this.filterArr[i]["value"] = this.viewByObj.category.arr;
            }
            if (this.filterArr[i]['key_name'] == "Employee") {
              this.filterArr[i]["value"] = this.viewByObj.user.arr;
            }
          }

          this.filterArr = [...this.filterArr];

          let newArr: any[] = JSON.parse(JSON.stringify(success["companies"]))
          newArr = newArr.map((item) => {
            delete item.sub_a;
            item["sub_a"] = item["sub_u"];
            delete item.sub_u;
            return item
          });
          this.viewByObj.c_user.arr = newArr;
          // company_name field is mapped to name because in filter if we use the field name then for the name it filter out the location name instead of company name
          this.viewByObj.company.arr = this.viewByObj.company.arr.map((item) => {
            item['company_name'] = item["name"]
            return item
          })

        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }

  // Job calendar
  // getList() {
  //   this.isLoading = true;
  //   let newArr: any[] = this.filterObj.arr;
  //   for (let i = 0; i < newArr.length; i++) {
  //     delete newArr[i]["key_name"]
  //     delete newArr[i]["arr"]
  //     //if(newArr[i]["key_name"]){}
  //     newArr[i]["filter_value"] = newArr[i]["field_name"]
  //     delete newArr[i]["field_name"]
  //   }
  //   let data = {
  //     "st": "0",
  //     "r_p": "10",
  //     "v_t": "employee",
  //     f_a: newArr,
  //     op_nd: this.filterObj.operand
  //   }

  //   if (this.viewMode == 'month') {
  //     data["st_dt"] = this.daysInMonth[0]["fDate"]
  //     data["ed_dt"] = this.daysInMonth[this.daysInMonth.length - 1]["fDate"]

  //     this.startDate = this.daysInMonth[0]['fDate']
  //     this.endDate = this.daysInMonth[this.daysInMonth.length - 1]["fDate"]
  //   }
  //   else if (this.viewMode == 'week') {
  //     data["st_dt"] = this.daysInWeek[0]["fDate"]
  //     data["ed_dt"] = this.daysInWeek[this.daysInWeek.length - 1]["fDate"]

  //     this.startDate = this.daysInWeek[0]["fDate"]
  //     this.endDate = this.daysInWeek[this.daysInWeek.length - 1]["fDate"]
  //   }
  //   else {
  //     data["st_dt"] = this.daysInDay["fDate"]
  //     data["ed_dt"] = this.daysInDay["fDate"]

  //     this.startDate = this.daysInDay["fDate"]
  //     this.endDate = this.daysInDay["fDate"]
  //   }

  //   this.jobService.getJobData(data).subscribe({
  //     next: (success: any) => {
  //       if (success.status == 200) {
  //         this.isLoading = false;
  //         this.jobData = []
  //         this.jobData = success.msg["j_d"]
  //         this.totalUnassignedShift = this.jobData.filter(item => item.op_s === 1).length;

  //         this.filteredJobData = [...this.jobData]
  //         this.filteredJobData = JSON.parse(JSON.stringify(this.jobData))

  //         this.viewByObj.category.arr = success.msg["category"]
  //         this.viewByObj.location.arr = success.msg['location']
  //         this.viewByObj.user.arr = success.msg["user"]
  //         this.viewByObj.company.arr = success.msg["company"]
  //         this.viewByObj.c_category.arr = success.msg["company"]

  //         for (let i = 0; i < this.filterArr.length; i++) {
  //           if (this.filterArr[i]['key_name'] == "Location") {
  //             this.filterArr[i]["value"] = this.viewByObj.location.arr;
  //           }
  //           if (this.filterArr[i]['key_name'] == "Company") {
  //             this.filterArr[i]["value"] = this.viewByObj.company.arr;
  //           }
  //           if (this.filterArr[i]['key_name'] == "Category") {
  //             this.filterArr[i]["value"] = this.viewByObj.category.arr;
  //           }
  //           if (this.filterArr[i]['key_name'] == "Employee") {
  //             this.filterArr[i]["value"] = this.viewByObj.user.arr;
  //           }
  //         }
  //         // reason here sub_u is mapped to sub_a is because in general for the sub array in filter we are using the sub_a hence we have mapped the field as below:
  //         let newArr: any[] = JSON.parse(JSON.stringify(success.msg["company"]))
  //         newArr = newArr.map((item) => {
  //           delete item.sub_a;
  //           item["sub_a"] = item["sub_u"];
  //           delete item.sub_u;
  //           return item
  //         });
  //         this.viewByObj.c_user.arr = newArr;
  //         // company_name field is mapped to name because in filter if we use the field name then for the name it filter out the location name instead of company name
  //         this.viewByObj.company.arr = this.viewByObj.company.arr.map((item) => {
  //           item['company_name'] = item["name"]
  //           return item
  //         })
  //         this.updateJobData();
  //         this.getUnavailability(data)
  //         this.spinner.hide()
  //       }
  //     },
  //     error: (error: any) => {
  //       this.isLoading = false;
  //       this.commonService.handleError(error);
  //     },
  //   });
  // }
  onDateChange(event) {
    this.currentDate = event.value['_d'];
    this.generateDayView()
  }
  getShiftColor(event: any) {
    if (event.op_s == 1) {
      return 'open-shift' //open shift
    }
    else {
      // job terminated.
      if (event.pause == 2) {
        return 'red-sh'
      }
      else if (event.pause == 1) {
        return 'yellow-sh'
      }
      else {
        if (event.em_st == 4) { return 'green-sh' }
        else if (event.em_st == 0 || event.em_st == 3) { return 'red-sh' }    // sick, absent
        else if (event.em_st == 1 || event.em_st == 2) { return 'yellow-sh' } // early or late
        else { return 'green-sh' }
      }
    }
  }
  //================================= Working and Not working Employee ========================================
  onCurrentTab(type: string) {
    this.currentTab = type;
    if (this.currentTab == 'working_emp') {
      // if recruiter
      if (this.userType = "recruiter") {
        this.displayedColumns = ['first_name', 'company_name', 'job_name', 'address', 'category', 'time', 'charges', 'status', 'action']
      }
      else {
        this.displayedColumns = ['first_name', 'job_name', 'address', 'category', 'time', 'charges', 'status', 'action']
      }
    }
    else {
      if (this.userType = "recruiter") {
        this.displayedColumns = ['first_name', 'company_name', 'job_name', 'address', 'category', 'time', 'status', 'action']
      }
      else {
        this.displayedColumns = ['first_name', 'job_name', 'address', 'category', 'time', 'status', 'action']
      }
    }
  }
  onDateClick(data) {
    this.getEmpData(data.fDate)
  }
  getEmpData(date) {
    let data = {
      date: date
    }
    this.jobService.getDateEmp(data).subscribe({
      next: (success: any) => {
        if (success["status"] == 200) {
          document.getElementById("detail-section")?.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
          });
          this.dataSource = new MatTableDataSource(success.msg.working_data);
          this.dataSourceNotClock = new MatTableDataSource(success.msg.not_clockin_data);
        }
      },
      error: (error: any) => {
        // this.spinner.hide();
        this.commonService.handleError(error);
      },
    });
  }
  confirmationAlert(dataObj: any, type: string, value: string) {

    let data = {
      j_id: dataObj.j_id,
      clock_id: dataObj.id,
      em_i: dataObj.em_i,
      app: "",
      ov_ti_app: "",
    };
    if (type == "overtime") {
      data["ov_ti_app"] = value;
    } else {
      data["app"] = value;
    }
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: {
        content_type: "accept_reject",
        dataObj: data,
        item_type: "time_clock_status",
        data_type: "change"
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.confirm_yes == true) {
        // this.getTodayList();
        this.getEmpData(dataObj.date)
      }
    });
  }
  onChangeEmpSt(item, value, date) {
    let dataObj = {
      "j_id": item.id,
      "em_i": item.em_i,
      "em_st": value
    }
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: { dataObj, content_type: "employee_status" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["confirm_yes"] == true) {
          this.getEmpData(date);
          this.getList2()
        }
      }
      if (result == undefined) {
      }
    });
  }
  // ===========================================================================================================
  onDeleteShift() {
    let data = { api_type: "delete_content", content_type: "delete_shift", id: this.hoverContent.j_id, comm_id: this.hoverContent.comm_id }
    if (data.id == null || data.id == undefined) {
      data.id = this.hoverContent.id;
    }
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: data
    },));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        this.getList2()
      }
    });
  }
  // ============================================================================================================
  getDivWidth() {
    var elements = document.getElementsByClassName('week-height');
    var divWidth = elements[0].clientWidth; // Access the first element in the collection
    return divWidth;
  }
  // =========================Duplicate and Multi Duplicate action=================================
  onDuplicate(val) {
    const data = {
      "j_id": this.hoverContent.j_id,
      "dup": val,
    }
    if (!data.j_id) {
      data.j_id = this.hoverContent.id;
    }
    this.jobService.duplicateJob(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.appService.showToastMessage('success', success.msg);
          this.getList2();
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    })
  }
  onAddMultiDup() {
    const dialogRef = this.dialog.open(AddMultiduplicateComponent, {
      width: '90%', maxWidth: "400px", height: "95%", maxHeight: '265px'
    });
    dialogRef.afterClosed().subscribe(result => {
      // o
      if (result && result.duplicate) {
        this.onDuplicate(result.duplicate)
      }
    });
  }
  // ===drag and drop============================================================================================
  onDropShiftAPI(item): Promise<boolean> {

    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }

    const data = item;
    if (this.viewMode == 'month') {
      data["j_st_dt"] = this.daysInMonth[0]["fDate"]
      data["j_ed_dt"] = this.daysInMonth[this.daysInMonth.length - 1]["fDate"]
    }
    else if (this.viewMode == 'week') {
      data["j_st_dt"] = this.daysInWeek[0]["fDate"]
      data["j_ed_dt"] = this.daysInWeek[this.daysInWeek.length - 1]["fDate"]
    }
    else {
      data["j_st_dt"] = this.daysInDay["fDate"]
      data["j_ed_dt"] = this.daysInDay["fDate"]
    }
    return new Promise<boolean>((resolve, reject) => {
      // Set a timeout to delay the API call
      this.resizeTimeout = setTimeout(() => {
        this.jobService.dragDropJob(data).subscribe({
          next: (success: any) => {
            if (success.status == 200) {
              resolve(true);  // Resolve with true if API is successful
              this.appService.showToastMessage('success', "Shift Data changed successfully");
              this.filteredJobData = []
              this.filteredJobData = success.msg.j_d
              // this.updateJobData(); i chnaged because api side data is changed //changed by ankush 
              this.getList2();

            }
            else {
              resolve(false); // Resolve with false if the API response is not as expected        
              this.getList2();
            }
          },
          error: (error: any) => {
            // this.commonService.handleError(error);
            resolve(false); // Resolve with false in case of error                       
            this.getList2();
          }
        })
      }, 1000);

      resolve(true);
    })
  }
  // ===Unassign Shift=============================================================================
  onUnassignShift() {
    let startDate = this.formatDate(
      this.viewMode === 'month' ? startOfMonth(this.currentMonth) :
        this.viewMode === 'week' ? startOfWeek(this.currentWeek) :
          this.currentDate
    );
    let endDate = this.formatDate(
      this.viewMode === 'month' ? endOfMonth(this.currentMonth) :
        this.viewMode === 'week' ? endOfWeek(this.currentWeek) :
          this.currentDate
    );
    const data = {
      "st_dt": startDate,
      "ed_dt": endDate,
      "pub_t": "2", // 1 = unpublish, 2 = un assign   
      "j_id": ''
    }
    this.spinner.show()
    this.jobService.unassignShift(data).subscribe({
      next: (success: any) => {
        this.spinner.hide()
        if (success.status == 200) {
          this.appService.showToastMessage('success', success.msg);
          this.getList2();
        }
        else {

        }
      },
      error: (error: any) => {
        this.spinner.hide()
        this.commonService.handleError(error);

      }
    })
  }
  // =====ON add Comments
  // company and admin can add comments for the specific employee
  onAddComments(item) {
    const dialogRef = this.dialog.open(StarRatingComponent, {
      width: '90%', maxWidth: "400px", height: "95%", maxHeight: '470px',
      data: { id: item.id, em_i: item.em_i }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  //==================view employee 
  onViewEmployee(id) {
    let data = {
      employee_id: id,
      type: 'company'
    }
    const dialogRef = this.dialog.open(ViewEmployeeComponent, {
      width: '95%',
      height: '95%',
      maxWidth: '95vw',
      panelClass: 'onboard-modal',
      data: data,
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  getTemplateList() {
    const data = {
      "type": "3" // 0 = shift, 1 = week template, 2 = day template, 3 = shift template
    }
    this.jobService.getTemplate(data).subscribe({
      next: (success: any) => {
        if (success["status"] == 200) {
          this.templateArr = [];
          this.templateArr = success.msg;
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onAddTemplate(item) {
    let modalData = {
      modalType: "add_template",
      addType: "shift_template",
      ...{ item }
    }
    const dialogRef = this.dialog.open(AddShiftComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      width: '98%', height: '98%',
      maxWidth: '700px',
      autoFocus: false,
      data: modalData
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getList2();
    });

  }
  // ================Extra functions
  getMaxWidthForWeekBox() {
    setTimeout(() => {
      const elemWidth = document.getElementById("week-box")?.offsetWidth;
      if (elemWidth) {
        this.maxWeekViewWidth = elemWidth;
      }
    })
  }
  getCountingAllThing() {
    const data = []
    this.jobService.getCounting(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {

        }
        else {

        }
      },
      error: (error: any) => {

      }
    })
  }
  // ==========================
  onConflicts() {

    let data = {
      startDate: this.startDate,
      endDate: this.endDate,
    }

    const dialogRef = this.dialog.open(ConflictsComponent, {
      enterAnimationDuration: "300ms",
      exitAnimationDuration: "300ms",
      width: '95%',
      height: '98%',
      maxWidth: '600px',
      autoFocus: false,
      data: data,
    });
    dialogRef.afterClosed().subscribe(result => {
    });
    // this.getAllCounting()
  }
  // ==============================================================================================
  getAllCounting() {
    let startDate = this.formatDate(
      this.viewMode === 'month' ? startOfMonth(this.currentMonth) :
        this.viewMode === 'week' ? startOfWeek(this.currentWeek) :
          this.currentDate
    );
    let endDate = this.formatDate(
      this.viewMode === 'month' ? endOfMonth(this.currentMonth) :
        this.viewMode === 'week' ? endOfWeek(this.currentWeek) :
          this.currentDate
    );
    let data = {
      "st_dt": startDate,
      "ed_dt": endDate,
      "v_t": "1" // 1 = view by c
    }
    this.jobService.getCountingAll(data).subscribe(response => {
    })
  }
  getTaskPercentage(item: any) {
    return ((item.tot_att / item.tot_task) * 100);
  }
  getUnavailability(data) {
    delete data["f_a"]
    delete data["op_nd"]
    delete data["r_p"]
    delete data["st"]
    delete data["v_t"]
    data["em_i"] = ""
    this.recruiterService.getUnavailability(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.unavailabilityArr = [];
          this.unavailabilityArr = success.msg;
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  //================================ End of the component===========================================
  ngOnDestroy() {
    if (this.weekClickListener) {
      document.removeEventListener('click', this.weekClickListener);
    }
  }


  getweekCounting() {
    let v_t;

    if (this.viewBy == "c_user") {
      v_t = "1"
    } else if (this.viewBy == "c_category") {
      v_t = "2"
    } else if (this.viewBy == "company") {
      v_t = "3"
    } else if (this.viewBy == "category") {
      v_t = "4"
    } else if (this.viewBy == "location") {
      v_t = "5"
    } else if (this.viewBy == "user") {
      v_t = "6"
    }

    // return;

    let data = {
      "v_t": v_t,
      "st_dt": this.daysInWeek[0]["fDate"],
      "ed_dt": this.daysInWeek[this.daysInWeek.length - 1]["fDate"],
    }

    this.jobService.getJobCounting(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.weekCountingArr = success.msg.date;
          this.weekCostCountingArr = success.msg.week;

          const updatedArray = this.weekCountingArr.map(item => ({
            ...item,
            per: item.day_t_sh ? ((item.day_w_sh / item.day_t_sh) * 100).toFixed(2) : 0
          }));

          this.daysInWeek = this.daysInWeek.map((day, index) => ({
            ...day,
            counting: {
              ...day.counting,
              ...updatedArray[index] // Merging object properties
            }
          }));
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });

  }

  toggleExpand2(index: number) {
    this.isMinimizedView2 = !this.isMinimizedView2;
    this.expandedState[index] = !this.expandedState[index];
  }


  onCoppyShift(event: any) {
    let data = {
      "j_id": event.j_id,
      "dup": "1"
    };
    this.spinner.show();
    this.jobService.dupJob(data).subscribe({
      next: (success: any) => {
        if (success["status"] == 200) {
          this.spinner.hide();
          this.appService.showToastMessage("success", success.msg);
          this.getList2()
        }
      },
      error: (error: any) => {
        this.spinner.hide();
        this.getList2()
        this.commonService.handleError(error);
      },
    });

  }

  //this function is for check image urls if image urls have https then return same url and if url dont have https then adding https and then send newurl
  checkUrl(url: any) {
    let newUrl;
    if (url?.includes("https")) {
      newUrl = url;
    } else {
      newUrl = GlobalService.imageURL + url;
    }
    return newUrl;
  }
  // ========================================END--------------
  // ========================================END--------------
  // ========================================END--------------                                                                                             
}




